import { Form, Input } from "antd"
import { t } from "i18next"

const isValidJson = (str: string): boolean => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const SeoForm = () => {
  return (
    <>
      <span className="text-base font-medium pt-2 pb-2">{t("SEO")}</span>
      <div className="grid grid-cols-2 gap-x-5 gap-y-2 p-5 border rounded-[10px]">
        <Form.Item name="metaTitle" label={<span className="text-base font-medium p">{t("Meta Title")}</span>}>
          <Input className="custom-input py-2" />
        </Form.Item>

        <Form.Item name="keywords" label={<span className="text-base font-medium">{t("Meta Keywords")}</span>}>
          <Input className="custom-input py-2" />
        </Form.Item>

        <Form.Item
          name="metaDescription"
          label={<span className="text-base font-medium">{t("Meta Description")}</span>}
        >
          <Input.TextArea className="custom-input py-2" rows={5} />
        </Form.Item>

        <Form.Item
          name="structuredData"
          label={<span className="text-base font-medium">{t("Structured Data")}</span>}
          rules={[
            {
              validator: (_, value) => {
                if (value && !isValidJson(value)) {
                  return Promise.reject(new Error(t("Invalid JSON format!")))
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <Input.TextArea className="custom-input py-2" rows={5} placeholder={t('@example: {"id": "string"}')} />
        </Form.Item>

        <Form.Item name="metaRobots" label={<span className="text-base font-medium">{t("Meta Robots")}</span>}>
          <Input className="custom-input py-2" />
        </Form.Item>

        <Form.Item name="metaViewport" label={<span className="text-base font-medium">{t("Meta Viewport")}</span>}>
          <Input className="custom-input py-2" />
        </Form.Item>

        <Form.Item name="canonicalURL" label={<span className="text-base font-medium">{t("Canonical URL")}</span>}>
          <Input className="custom-input py-2" />
        </Form.Item>
      </div>
    </>
  )
}

export default SeoForm
